/**
 * `next/router` — the pages-router shim handed to federated remotes.
 *
 * Two exposed remote modules call `useRouter()`: microapp-cii's cii-detail and
 * microapp-eeoi's eeoi-detail, both of which gate on `router.isReady` before reading
 * `router.query.dataKey`. Through the `shared` block in rspack.config.js they resolve
 * this module rather than the Next copy inside their own container, so they end up on
 * the same router instance as the shell.
 *
 * There is no separate implementation here: this is the shell's own router under the
 * name Next-built code knows it by. Adding behaviour to one and not the other is how
 * a remote and its host end up disagreeing about what the current route is.
 */

import { useShellRouter } from '@/hooks/useShellRouter';
import { routerEvents } from './router-events';

export type { ShellRouter as NextRouter } from '@/hooks/useShellRouter';

export const useRouter = useShellRouter;

export default { useRouter, events: routerEvents };
